import { defineComponent as _defineComponent } from 'vue'
import { formatStripePrice } from "@/helpers/transformation/price";
  import { computed } from "vue";
  import { CustomTerms } from "@/types/CustomTerms";

  interface Props {
    isRefundable: boolean;
    deposit: number;
    isZeroDeposit: boolean;
    customTerms: CustomTerms;
    isEmailBelongsToCustomer: boolean | null;
    hasInitialHoldEmailError: boolean;
  }
  
export default /*@__PURE__*/_defineComponent({
  __name: 'EOIInfoMessage',
  props: {
    isRefundable: { type: Boolean },
    deposit: {},
    isZeroDeposit: { type: Boolean },
    customTerms: {},
    isEmailBelongsToCustomer: { type: [Boolean, null] },
    hasInitialHoldEmailError: { type: Boolean }
  },
  setup(__props: any, { expose: __expose }) {
  __expose();

  const props = __props;
  const showCustomOnlyTerms = computed(() => {
    return props.customTerms.showOnlyCustomTerms && !!props.customTerms.text;
  });

const __returned__ = { props, showCustomOnlyTerms, get formatStripePrice() { return formatStripePrice }, computed, get CustomTerms() { return CustomTerms } }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})